import { styled as muiStyled, Paper } from '@mui/material'

export const StyledRequestTherapyComponent = muiStyled(Paper)(
  ({ theme }) => `
    width: 100%;
`,
)

export const ConsultsTabTableContainer = muiStyled('div')(
  ({ theme }) => `
    td {
        background: transparent;
    }
`,
)

export const StyledSendPrescriptionDataDialogPaper = muiStyled(Paper)(
  ({ theme }) => `
    width: 100% !important;
    margin: 0px !important;
`,
)
